(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-back-in-stock"] && !Shopify.designMode) return;
  try {
    class KlaviyoBackInStock extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.form = this.querySelector('form')
      this.button = this.querySelector('button')
      this.emailInput = this.querySelector('[name="email"]')
      this.successMessage = this.querySelector('.js-success-message')
      this.companyId = this.querySelector('[name="company_id"]')?.value || null;

      if( this.companyId === null ) {
        console.error('missing company id');
        return
      }

      this.form.addEventListener('submit', async (event) => {
        event.preventDefault()
        event.stopPropagation();

        this.button.classList.add('loading')
        this.emailInput.setAttribute('disabled', true)

        this.querySelector('.button__icon__svg').classList.add('hidden')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.emailInput.setCustomValidity('Please enter a valid email address')
          this.emailInput.reportValidity()
          return
        }

        this.emailInput.setCustomValidity('')

        const variantId = this.form.querySelector('input[name="variant_id"]').value
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: `${email}`,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        }

        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`,
          options,
        )
        if (response) {
          this.successMessage.classList.remove('visually-hidden')
          this.form.classList.add('visually-hidden');
          // setTimeout(function(){
          //   this.successMessage.classList.add('visually-hidden')
          //   this.form.classList.remove('visually-hidden');
          // }, 3000)
        }
        this.button.classList.remove('loading')
        this.emailInput.removeAttribute('disabled')
        this.querySelector('.button__icon__svg').classList.remove('hidden')
        this.querySelector('.loading__spinner').classList.add('hidden')
      })

      // Add input validation on email changes
      this.emailInput.addEventListener('input', () => {
        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.button.setAttribute('disabled', true)
          this.emailInput.setCustomValidity('Please enter a valid email address')
        } else {
          this.button.removeAttribute('disabled')
          this.emailInput.setCustomValidity('')
        }
      })
    }
  }

  if (!customElements.get('klaviyo-back-in-stock')) {
    customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);
  }
  } catch(e) { console.error(e); }
})();

})();
